var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "text-center" },
        [
          _c(
            "b-form",
            { on: { submit: _vm.onSubmit } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-name",
                    label: "Nom",
                    "label-for": "input-name",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "input-name", type: "text", required: "" },
                    model: {
                      value: _vm.form.item_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "item_name", $$v)
                      },
                      expression: "form.item_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-color",
                    label: "Couleur",
                    "label-for": "input-color",
                  },
                },
                [
                  _c("v-swatches", {
                    attrs: { id: "input-color", swatches: _vm.swatches },
                    model: {
                      value: _vm.form.item_color,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "item_color", $$v)
                      },
                      expression: "form.item_color",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [_vm._v("Valider")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }